import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import alacuentaTheme from '../themes/alacuentaTheme';
import AppToolBar from '../components/app-toolbar/AppToolBar';
import { useMediaQuery } from '@mui/material';
import ReactGA from 'react-ga4';

const MasterPage = () => {
  const isMobileVersion = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    // Configura el ID de seguimiento
    ReactGA.initialize('G-0YNHC0Y350');
    // Informa la página vista
    const url = window.location.pathname + window.location.search;
    ReactGA.send({ hitType: "pageview", page: url, title: window.location.search });
  }, []);

  return (
    <div className="App">
      <AppToolBar isMobileVersion={isMobileVersion} showShoppingCar={true} />
      <ThemeProvider theme={alacuentaTheme}>
        <Outlet />
      </ThemeProvider>
    </div>
  );
}

export default MasterPage;
